import {observer} from "mobx-react-lite";
import * as React from "react";
import {WhoisDomainData} from "../../models/ioc";
import {Table} from "react-bootstrap";
import DateRow from "../DateRow";

const WhoisDomainResults = observer(function WhoisDomainResults(props: { data: WhoisDomainData }) {
    const {data} = props

    return <Table>
        <tbody>
        <tr>
            <td><strong>Created: </strong></td>
            <td><DateRow timestamp={data.creation_date}/></td>
        </tr>
        <tr>
            <td><strong>Last Updated: </strong></td>
            <td><DateRow timestamp={data.updated_date}/></td>
        </tr>
        <tr>
            <td><strong>Expiration: </strong></td>
            <td><DateRow timestamp={data.expiration_date}/></td>
        </tr>
        <tr>
            <td colSpan={2}><strong>Contacts</strong></td>
        </tr>
        <tr>
            <td colSpan={2}>
                <Table bordered striped>
                    <thead>
                    <tr>
                        <td>Name</td>
                        <td>Organization</td>
                        <td>Email</td>
                        <td>Street</td>
                        <td>City</td>
                        <td>State</td>
                        <td>Postal Code</td>
                        <td>Country</td>
                    </tr>
                    </thead>
                    <tbody>
                    {data.contacts.map((v, i) => <tr key={i}>
                        <td>{v.name}</td>
                        <td>{v.organization}</td>
                        <td>{v.emails}</td>
                        <td>{v.address}</td>
                        <td>{v.city}</td>
                        <td>{v.state}</td>
                        <td>{v.postal_code}</td>
                        <td>{v.country}</td>
                    </tr>)}
                    </tbody>
                </Table>
            </td>
        </tr>
        </tbody>
    </Table>
})

export default WhoisDomainResults